import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../api';
import { ReadWorkspaceResponse } from '../api/workspace-model';
import { WorkspaceVersionDto } from '../api/workspace-version-model';

export const fetchWorkspace = createAsyncThunk(
    'workspace/fetchWorkspace',
    async (workspaceId: string): Promise<ReadWorkspaceResponse> =>
        await Api.defaultApi().fetchWorkspace(workspaceId)
);

export const fetchWorkspaceVersion = createAsyncThunk(
    'workspace/fetchWorkspaceVersion',
    async (): Promise<WorkspaceVersionDto> =>
        await Api.defaultApi().fetchWorkspaceVersion()
);
